export default "__VITE_ASSET__ClCY6nDZ__"